import { render, staticRenderFns } from "./playerVotes.vue?vue&type=template&id=b9889de6&"
import script from "./playerVotes.vue?vue&type=script&lang=js&"
export * from "./playerVotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports